import { Button, HStack, Text, VStack } from '@/components/sgBootstrapReactWrapper';
import { Field } from './Field';
import { getFieldName, type PositionType, type Template } from './template';
import { FormattedMessage } from 'react-intl';
import { FormattedValue } from './FormattedValue';

type Props = {
  position: PositionType;
  onClose: () => void;
  template: Template;
}

export const PositionDetailsDrawerHeader = ({ position, onClose, template }: Props) => {
  const fields = template.headerFields.map((fieldSpec) => (
    <Field header key={getFieldName(fieldSpec)} fieldSpec={fieldSpec} position={position} positionType={template.type} />
  ));

  const translatedFieldNameI18key = `operation.drawer.${template.title}`
  const fieldNameElement = <FormattedMessage id={translatedFieldNameI18key} />

  return (
    <VStack gap="16px" padding="24px">
      <HStack className="justify-content-between">
        <VStack>
          <Text className="display-4"><FormattedMessage id={`asset.${template.type}`} /></Text>
          <HStack gap="8px" className="pt-8px">
            <div className="text-secondary">{fieldNameElement}</div>
            <div>
              <FormattedValue fieldSpec={template.title} position={position} />
            </div>
          </HStack>
        </VStack>
        <Button
          size="sm"
          purpose="flat"
          onClick={onClose}
          className="p-8px"
          data-e2e="instrument-drawer-close">
          <em className="icon icon-lg text-primary">close</em>
        </Button>
      </HStack>
      <div className="grid gx-16 gy-0">{fields}</div>
    </VStack>
  );
};
